module.exports = __webpack_public_path__ + "img/filter1.242faf31.png";